module.exports = __webpack_public_path__ + "img/icb-co-Adv-e@3x.7ccc3ed4.png";